module.exports = __webpack_public_path__ + "img/screenshot-step3.328fa7e6.png";